import type { Event } from '../../interface/event';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getNextEvents = async () => {
  try {
    const {
      data: { data: events },
    } = await api.get<{ data: Event[] }>(apiConfig.routes.events.listNexts);

    return events;
  } catch {
    const {
      data: { data: events },
    } = await api.get<{ data: Event[] }>(
      apiConfig.routes.events.publicListNexts
    );

    return events;
  }
};

export const useGetNextEvents = () =>
  useQuery({
    queryKey: ['events', 'next'],
    queryFn: getNextEvents,
  });
